
import { css } from 'lit';
export default css`
:host {
  display: block;
}

:host ul, :host ol, .cke_editable ul, .cke_editable ol, .field--name-body ul, .field--name-body ol, .field--name-field-response ul, .field--name-field-response ol, ul.default, ol.default, ul.light, ol.light, ol.lower-alpha, ol.lower-alpha-light {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  list-style-position: outside;
  list-style-type: none;
  padding: 0px;
}

:host ul li, :host ol li, .cke_editable ul li, .cke_editable ol li, .field--name-body ul li, .field--name-body ol li, .field--name-field-response ul li, .field--name-field-response ol li, ul.default li, ol.default li, ul.light li, ol.light li, ol.lower-alpha li, ol.lower-alpha-light li {
  position: relative;
}

:host ul li, :host ol li, .cke_editable ul li, .cke_editable ol li, .field--name-body ul li, .field--name-body ol li, .field--name-field-response ul li, .field--name-field-response ol li, ul.default li, ol.default li, ul.light li, ol.light li, ol.lower-alpha li, ol.lower-alpha-light li {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

:host ul li, :host ol li, .cke_editable ul li, .cke_editable ol li, .field--name-body ul li, .field--name-body ol li, .field--name-field-response ul li, .field--name-field-response ol li, ul.default li, ol.default li, ul.light li, ol.light li, ol.lower-alpha li, ol.lower-alpha-light li {
  font-family: Lato, sans-serif;
}

:host ul li, :host ol li, .cke_editable ul li, .cke_editable ol li, .field--name-body ul li, .field--name-body ol li, .field--name-field-response ul li, .field--name-field-response ol li, ul.default li, ol.default li, ul.light li, ol.light li, ol.lower-alpha li, ol.lower-alpha-light li {
  font-size: 1rem;
}

:host ul li, :host ol li, .cke_editable ul li, .cke_editable ol li, .field--name-body ul li, .field--name-body ol li, .field--name-field-response ul li, .field--name-field-response ol li, ul.default li, ol.default li, ul.light li, ol.light li, ol.lower-alpha li, ol.lower-alpha-light li {
  line-height: 1.5;
}

:host ul li, :host ol li, .cke_editable ul li, .cke_editable ol li, .field--name-body ul li, .field--name-body ol li, .field--name-field-response ul li, .field--name-field-response ol li, ul.default li, ol.default li, ul.light li, ol.light li, ol.lower-alpha li, ol.lower-alpha-light li {
  letter-spacing: 0em;
}

@media (min-width: 1024px) {

  :host ul li, :host ol li, .cke_editable ul li, .cke_editable ol li, .field--name-body ul li, .field--name-body ol li, .field--name-field-response ul li, .field--name-field-response ol li, ul.default li, ol.default li, ul.light li, ol.light li, ol.lower-alpha li, ol.lower-alpha-light li {
    font-size: 1.25rem;
  }
}

:host ul li, :host ol li, .cke_editable ul li, .cke_editable ol li, .field--name-body ul li, .field--name-body ol li, .field--name-field-response ul li, .field--name-field-response ol li, ul.default li, ol.default li, ul.light li, ol.light li, ol.lower-alpha li, ol.lower-alpha-light li {
    padding: 0 0 0 1.5rem;
  }

:host ul li::marker, :host ol li::marker, .cke_editable ul li::marker, .cke_editable ol li::marker, .field--name-body ul li::marker, .field--name-body ol li::marker, .field--name-field-response ul li::marker, .field--name-field-response ol li::marker, ul.default li::marker, ol.default li::marker, ul.light li::marker, ol.light li::marker, ol.lower-alpha li::marker, ol.lower-alpha-light li::marker {
      display: none;
      content: "";
    }

:host ul li::marker, :host ol li::marker, .cke_editable ul li::marker, .cke_editable ol li::marker, .field--name-body ul li::marker, .field--name-body ol li::marker, .field--name-field-response ul li::marker, .field--name-field-response ol li::marker, ul.default li::marker, ol.default li::marker, ul.light li::marker, ol.light li::marker, ol.lower-alpha li::marker, ol.lower-alpha-light li::marker {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

:host ul li::marker, :host ol li::marker, .cke_editable ul li::marker, .cke_editable ol li::marker, .field--name-body ul li::marker, .field--name-body ol li::marker, .field--name-field-response ul li::marker, .field--name-field-response ol li::marker, ul.default li::marker, ol.default li::marker, ul.light li::marker, ol.light li::marker, ol.lower-alpha li::marker, ol.lower-alpha-light li::marker {
      font-size: 1.85rem;
    }

:host ul li p, :host ol li p, .cke_editable ul li p, .cke_editable ol li p, .field--name-body ul li p, .field--name-body ol li p, .field--name-field-response ul li p, .field--name-field-response ol li p, ul.default li p, ol.default li p, ul.light li p, ol.light li p, ol.lower-alpha li p, ol.lower-alpha-light li p {
      display: inline;
    }

:host ul.list--1-column, :host ol.list--1-column, .cke_editable ul.list--1-column, .cke_editable ol.list--1-column, .field--name-body ul.list--1-column, .field--name-body ol.list--1-column, .field--name-field-response ul.list--1-column, .field--name-field-response ol.list--1-column, ul.default.list--1-column, ol.default.list--1-column, ul.light.list--1-column, ol.light.list--1-column, ol.lower-alpha.list--1-column, ol.lower-alpha-light.list--1-column {
    -moz-column-count: 1;
         column-count: 1;
  }

:host ul.list--2-columns, :host ol.list--2-columns, .cke_editable ul.list--2-columns, .cke_editable ol.list--2-columns, .field--name-body ul.list--2-columns, .field--name-body ol.list--2-columns, .field--name-field-response ul.list--2-columns, .field--name-field-response ol.list--2-columns, ul.default.list--2-columns, ol.default.list--2-columns, ul.light.list--2-columns, ol.light.list--2-columns, ol.lower-alpha.list--2-columns, ol.lower-alpha-light.list--2-columns {
    -moz-column-count: 2;
         column-count: 2;
  }

:host ul.list--3-columns, :host ol.list--3-columns, .cke_editable ul.list--3-columns, .cke_editable ol.list--3-columns, .field--name-body ul.list--3-columns, .field--name-body ol.list--3-columns, .field--name-field-response ul.list--3-columns, .field--name-field-response ol.list--3-columns, ul.default.list--3-columns, ol.default.list--3-columns, ul.light.list--3-columns, ol.light.list--3-columns, ol.lower-alpha.list--3-columns, ol.lower-alpha-light.list--3-columns {
    -moz-column-count: 3;
         column-count: 3;
  }

:host ul.list--1-column li, :host ul.list--2-columns li, :host ul.list--3-columns li, :host ol.list--1-column li, :host ol.list--2-columns li, :host ol.list--3-columns li, .cke_editable ul.list--1-column li, .cke_editable ul.list--2-columns li, .cke_editable ul.list--3-columns li, .cke_editable ol.list--1-column li, .cke_editable ol.list--2-columns li, .cke_editable ol.list--3-columns li, .field--name-body ul.list--1-column li, .field--name-body ul.list--2-columns li, .field--name-body ul.list--3-columns li, .field--name-body ol.list--1-column li, .field--name-body ol.list--2-columns li, .field--name-body ol.list--3-columns li, .field--name-field-response ul.list--1-column li, .field--name-field-response ul.list--2-columns li, .field--name-field-response ul.list--3-columns li, .field--name-field-response ol.list--1-column li, .field--name-field-response ol.list--2-columns li, .field--name-field-response ol.list--3-columns li, ul.default.list--1-column li, ul.default.list--2-columns li, ul.default.list--3-columns li, ol.default.list--1-column li, ol.default.list--2-columns li, ol.default.list--3-columns li, ul.light.list--1-column li, ul.light.list--2-columns li, ul.light.list--3-columns li, ol.light.list--1-column li, ol.light.list--2-columns li, ol.light.list--3-columns li, ol.lower-alpha.list--1-column li, ol.lower-alpha.list--2-columns li, ol.lower-alpha.list--3-columns li, ol.lower-alpha-light.list--1-column li, ol.lower-alpha-light.list--2-columns li, ol.lower-alpha-light.list--3-columns li {
  margin-top: 0px;
}

:host ul.list--1-column li, :host ul.list--2-columns li, :host ul.list--3-columns li, :host ol.list--1-column li, :host ol.list--2-columns li, :host ol.list--3-columns li, .cke_editable ul.list--1-column li, .cke_editable ul.list--2-columns li, .cke_editable ul.list--3-columns li, .cke_editable ol.list--1-column li, .cke_editable ol.list--2-columns li, .cke_editable ol.list--3-columns li, .field--name-body ul.list--1-column li, .field--name-body ul.list--2-columns li, .field--name-body ul.list--3-columns li, .field--name-body ol.list--1-column li, .field--name-body ol.list--2-columns li, .field--name-body ol.list--3-columns li, .field--name-field-response ul.list--1-column li, .field--name-field-response ul.list--2-columns li, .field--name-field-response ul.list--3-columns li, .field--name-field-response ol.list--1-column li, .field--name-field-response ol.list--2-columns li, .field--name-field-response ol.list--3-columns li, ul.default.list--1-column li, ul.default.list--2-columns li, ul.default.list--3-columns li, ol.default.list--1-column li, ol.default.list--2-columns li, ol.default.list--3-columns li, ul.light.list--1-column li, ul.light.list--2-columns li, ul.light.list--3-columns li, ol.light.list--1-column li, ol.light.list--2-columns li, ol.light.list--3-columns li, ol.lower-alpha.list--1-column li, ol.lower-alpha.list--2-columns li, ol.lower-alpha.list--3-columns li, ol.lower-alpha-light.list--1-column li, ol.lower-alpha-light.list--2-columns li, ol.lower-alpha-light.list--3-columns li {
  margin-bottom: 1rem;
}

ul.default ol li::before, ul.light ol li::before {
  vertical-align: baseline;
}

ul.default ol li::before, ul.light ol li::before {
      background: none;
    }

ol.default ul li::before, ol.lower-alpha ul li::before {
  vertical-align: middle;
}

ol.default ul li::before, ol.lower-alpha ul li::before {
      width: 8px;
      content: '';
    }

:host ul>li:before, .cke_editable ul>li:before, .field--name-body ul>li:before, .field--name-field-response ul>li:before, ul.default>li:before {
  margin-right: 0.5rem;
}

:host ul>li:before, .cke_editable ul>li:before, .field--name-body ul>li:before, .field--name-field-response ul>li:before, ul.default>li:before {
  margin-top: -2px;
}

:host ul>li:before, .cke_editable ul>li:before, .field--name-body ul>li:before, .field--name-field-response ul>li:before, ul.default>li:before {
  display: inline-block;
}

:host ul>li:before, .cke_editable ul>li:before, .field--name-body ul>li:before, .field--name-field-response ul>li:before, ul.default>li:before {
  height: 0.625rem;
}

:host ul>li:before, .cke_editable ul>li:before, .field--name-body ul>li:before, .field--name-field-response ul>li:before, ul.default>li:before {
  width: 0.625rem;
}

:host ul>li:before, .cke_editable ul>li:before, .field--name-body ul>li:before, .field--name-field-response ul>li:before, ul.default>li:before {
  border-width: 1px;
}

:host ul>li:before, .cke_editable ul>li:before, .field--name-body ul>li:before, .field--name-field-response ul>li:before, ul.default>li:before {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

:host ul>li:before, .cke_editable ul>li:before, .field--name-body ul>li:before, .field--name-field-response ul>li:before, ul.default>li:before {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

:host ul>li:before, .cke_editable ul>li:before, .field--name-body ul>li:before, .field--name-field-response ul>li:before, ul.default>li:before {
  vertical-align: middle;
}

:host ul>li:before, .cke_editable ul>li:before, .field--name-body ul>li:before, .field--name-field-response ul>li:before, ul.default>li:before {
    content: '';
    border-radius: 50%;
    position: absolute;
    top: 0.75rem;
    left: 0;
  }

ul.light>li:before {
  margin-right: 0.5rem;
}

ul.light>li:before {
  margin-top: -2px;
}

ul.light>li:before {
  display: inline-block;
}

ul.light>li:before {
  height: 0.625rem;
}

ul.light>li:before {
  width: 0.625rem;
}

ul.light>li:before {
  border-width: 1px;
}

ul.light>li:before {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

ul.light>li:before {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 242, 242, var(--tw-bg-opacity));
}

ul.light>li:before {
  vertical-align: middle;
}

ul.light>li:before {
    content: '';
    border-radius: 50%;
  }

:host ol,
.cke_editable ol,
.field--name-body ol,
.field--name-field-response ol,
ol.default {
  counter-reset: hf-ol;
}

:host ol>li, .cke_editable ol>li, .field--name-body ol>li, .field--name-field-response ol>li, ol.default>li {
    counter-increment: hf-ol;
  }

:host ol>li:before, .cke_editable ol>li:before, .field--name-body ol>li:before, .field--name-field-response ol>li:before, ol.default>li:before {
  display: inline-block;
}

:host ol>li:before, .cke_editable ol>li:before, .field--name-body ol>li:before, .field--name-field-response ol>li:before, ol.default>li:before {
  width: 1.25rem;
}

:host ol>li:before, .cke_editable ol>li:before, .field--name-body ol>li:before, .field--name-field-response ol>li:before, ol.default>li:before {
  font-weight: 800;
}

:host ol>li:before, .cke_editable ol>li:before, .field--name-body ol>li:before, .field--name-field-response ol>li:before, ol.default>li:before {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

:host ol>li:before, .cke_editable ol>li:before, .field--name-body ol>li:before, .field--name-field-response ol>li:before, ol.default>li:before {
      content: counter(hf-ol) '. ';
      position: absolute;
      left: 0;
    }

ol.light {
  counter-reset: hf-ol;
}

ol.light>li {
    counter-increment: hf-ol;
  }

ol.light>li:before {
  display: inline-block;
}

ol.light>li:before {
  width: 1.25rem;
}

ol.light>li:before {
  font-weight: 800;
}

ol.light>li:before {
  --tw-text-opacity: 1;
  color: rgba(242, 242, 242, var(--tw-text-opacity));
}

ol.light>li:before {
      content: counter(hf-ol) '. ';
    }

ol.lower-alpha {
  counter-reset: hf-la;
  list-style-type: lower-alpha;
}

ol.lower-alpha>li {
    counter-increment: hf-la;
  }

ol.lower-alpha>li:before {
  display: inline-block;
}

ol.lower-alpha>li:before {
  width: 1.25rem;
}

ol.lower-alpha>li:before {
  vertical-align: baseline;
}

ol.lower-alpha>li:before {
  font-weight: 800;
}

ol.lower-alpha>li:before {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

ol.lower-alpha>li:before {
      content: counter(hf-la, lower-alpha) '. ';
    }

ol.lower-alpha-light {
  counter-reset: hf-la;
  list-style-type: lower-alpha;
}

ol.lower-alpha-light>li {
    counter-increment: hf-la;
  }

ol.lower-alpha-light>li:before {
  display: inline-block;
}

ol.lower-alpha-light>li:before {
  width: 1.25rem;
}

ol.lower-alpha-light>li:before {
  vertical-align: baseline;
}

ol.lower-alpha-light>li:before {
  font-weight: 800;
}

ol.lower-alpha-light>li:before {
  --tw-text-opacity: 1;
  color: rgba(242, 242, 242, var(--tw-text-opacity));
}

ol.lower-alpha-light>li:before {
      content: counter(hf-la, lower-alpha) '. ';
    }

@media print {
  ol.default > li::before {
    font-weight: 400;
  }
  ol.default > li::before {
    color: #000;
    font-size: 16px;
  }

  ul.default > li::before {
    background: none;
    width: 0;
    height: 0;
    margin: 0;
  }
}
`;